import React from 'react';
import {
  SettingOutlined,
  AppstoreOutlined,
  HistoryOutlined,
  StarOutlined,
  UserOutlined
} from '@ant-design/icons';
import { Menu } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../UserAuth/AuthContext';

const LeftMenu = ({ collapsed }) => {
  const { userData } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const items = [
    {
      key: '/app/home',
      icon: <AppstoreOutlined />,
      label: 'Product Info',
      className: 'LeftMenuLI',
    },
    {
      key: '/app/attributes',
      icon: <SettingOutlined />,
      label: 'Attributes',
      className: 'LeftMenuLI',
    },
    {
      key: '/app/new-to-strum',
      icon: <StarOutlined />,
      label: 'New to Strum',
      className: 'LeftMenuLI',
    },
  ];

  if (userData?.data?.access === 'ALL') {
    items.push({
      key: '/app/audit_logs',
      icon: <HistoryOutlined />,
      label: 'Audit Logs',
      className: 'LeftMenuLI',
    });
  }

  items.push({
    key: '/app/customers',
    icon: <UserOutlined />,
    label: 'Customers',
    className: 'LeftMenuLI',
  });

  const handleClick = ({ key }) => {
    navigate(key); // key is like "/app/attributes"
  };

  // Define all product-related paths
  const productPaths = [
    '/app/home',
    '/app/kits',
    '/app/bundles',
    '/app/simple_products',
    '/app/sample-promotion-products',
    '/app/variants',
  ];

  // Determine which menu key should be selected
  let selectedMenuKey = location.pathname;
  if (productPaths.includes(location.pathname)) {
    selectedMenuKey = '/app/home'; // Always highlight Product Info for these paths
  }

  if (location.pathname.startsWith('/app/customers')) {
    selectedMenuKey = '/app/customers';
  }

  return (
    <Menu
      className='LeftMenuBox'
      mode="inline"
      theme="dark"
      inlineCollapsed={collapsed}
      selectedKeys={[selectedMenuKey]} // highlight current route or product info
      items={items}
      onClick={handleClick}
    />
  );
};

export default LeftMenu;
